namespace Vit.Administration {
    export interface UserTenantRoleGridDialogOptions extends JQueryUI.DialogOptions {
        userID: number;
        username: string;
    }
    @Serenity.Decorators.registerClass()
    export class UserTenantRoleGridDialog extends Serenity.TemplatedDialog<UserTenantRoleGridDialogOptions>{

        constructor(opt: UserTenantRoleGridDialogOptions) {
            super(opt);
            new UserTenantRoleGrid($('#UserTenantRoleGrid'), opt).init();
        }

        protected getTemplate() {
            // return '<div id="s-DialogContent"><div id="~_BusinessUnitsLookupEditor"></div><div id="~_BusinessUnits"></div><div id="~_Roles"></div></div>';
            return '<div id="s-DialogContent"><div id="UserTenantRoleGrid"></div></div>';
        }

        protected getDialogOptions() {
            let opt = super.getDialogOptions();

            opt.title = Q.format(Q.text("Site.UserRoleDialog.DialogTitle"), this.options.username);
            //opt.buttons = [{
            //    text: Q.text("Dialogs.OkButton"),
            //    click: () => {
            //        UserTenantRoleService.Update({
            //            UserID: this.options.userID,
            //            // Entities:,
            //        }, response => {
            //            debugger;
            //            // this.dialogClose();
            //            // Q.notifySuccess(Q.text("Site.UserRoleDialog.SaveSuccess"));
            //        });
            //    },
            //}, {
            //    text: Q.text("Dialogs.CancelButton"),
            //    click: () => this.dialogClose(),
            //}];

            return opt;
        }
    }

    @Serenity.Decorators.registerClass()
    export class UserTenantRoleGrid extends Serenity.EntityGrid<UserTenantRoleRow, any> {
        protected getColumnsKey() { return "Administration.UserTenantRole"; }
        protected getDialogType() { return TenantRoleDialog; }
        protected getNewDialogType() { return TenantRoleDialog; }
        protected getIdProperty() { return UserTenantRoleRow.idProperty; }
        //protected getIsActiveProperty() { return UserTenantRoleRow.isActiveProperty; }
        protected getLocalTextPrefix() { return UserTenantRoleRow.localTextPrefix; }
        protected getService() { return UserTenantRoleService.baseUrl; }


        constructor(container: JQuery, protected opt: UserTenantRoleGridDialogOptions) {
            super(container);
        }

        protected Test() {
            this.getDialogOptions();
        }

        protected onViewSubmit(): boolean {
            if (!super.onViewSubmit())
                return false;

            var request = this.view.params;
            request["UserId"] = this.opt.userID;
            return true;
        }

        
        protected getDefaultSortBy() {
            return [UserTenantRoleRow.Fields.TenantName];
        }

        protected getDialogOptions(): JQueryUI.DialogOptions {
            return this.opt;
        }
        protected getDialogOptionsFor(itemType: string): JQueryUI.DialogOptions {
            return this.opt;
        }
    }

}